module.exports = __webpack_public_path__ + "static/page3-82b0bde50608a4f27824491d3e3970c7.png";